// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"30b48890","453":"0feb56a7","500":"e0928ae9","565":"f4aa0c0b","781":"6402572f"}[chunkId] + ".chunk.js";
};